import { fileFormToUpdate } from '@/_containers';
import { nullableStringToNullableIntConverter } from '@/_schemas/generic';
import { statusToStr } from '@/_schemas/status-input';
import { getUniqueRelationshipIds } from '@/_shared';

import type { CompanyFormSchema, CompanyUpdateSchema } from '../schemas';

export function clientFormToUpdate({
  status,
  year_established,
  logo,
  phone_numbers,
  brand,
  account_manager,
  partner,
  relationship_score,
  audience,
  organization_type,
  billing_system,
  magazine,
  annual_meeting_month,
  contacts,
  domains,
  addresses,
  industries,
  all_gnt_affiliations,
  all_non_gnt_affiliations,
  subsidiaries,
  primary_contact,
  primary_subsidiaries,
  billing_term,
  box,
  freshdesk,
  harvest,
  ...rest
}: CompanyFormSchema): CompanyUpdateSchema {
  const relationshipInfo = getUniqueRelationshipIds({ main: contacts || [], primary: primary_contact || [] });

  return {
    ...rest,
    status: statusToStr(status),
    logo: fileFormToUpdate(logo),
    year_established: year_established === null ? null : parseInt(year_established.value, 10),
    phone_numbers: phone_numbers?.map((item) => item.id) ?? [],
    annual_meeting_month: annual_meeting_month === null ? null : annual_meeting_month.value,
    consumers: rest.consumers ? Number(rest.consumers.split(',').join('').trim()) : null,
    brand_id: brand?.id ?? null,
    partner_id: partner?.id ?? null,
    account_manager_id: account_manager?.id ?? null,
    relationship_score_id: relationship_score?.id ?? null,
    audience_id: audience?.id ?? null,
    organization_type_id: organization_type?.id ?? null,
    billing_system_id: billing_system?.id ?? null,
    magazine_id: magazine?.id ?? null,
    domains: domains?.map((item) => item.id) ?? [],
    addresses: addresses?.map((item) => item.id) ?? [],
    industries: industries?.map((item) => item.id) ?? [],
    gnt_affiliations: all_gnt_affiliations?.map((item) => item.id) ?? [],
    non_gnt_affiliations: all_non_gnt_affiliations?.map((item) => item.id) ?? [],
    primary_contact: relationshipInfo.primaryIds,
    alternate_contacts: relationshipInfo.alternateIds,
    subsidiaries: subsidiaries?.map((item) => item.id) ?? [],
    primary_subsidiaries: primary_subsidiaries?.map((item) => item.id) ?? [],
    billing_term_id: billing_term?.id ?? null,

    box: nullableStringToNullableIntConverter(box),
    freshdesk: nullableStringToNullableIntConverter(freshdesk),
    harvest: nullableStringToNullableIntConverter(harvest),
  };
}
